import React, { useState, useRef } from "react";
import HomePgImg2 from './../../../images/homepgimg2.png'
import HomePgImg2Mob from './../../../images/homepgimg2mob.png'
import HomePgImg4 from './../../../images/homepgimg4.png'
import HomePgImg5Mob from './../../../images/homepgimg5mob.png'
import NerveBlackRose from './../../../images/blackrose.png'
import HomePgImg7 from './../../../images/homepgimg7.png'
import HomePgImg7Mob from './../../../images/homepgimg7mob.png'
import nerveverticaltxt from './../../../images/nerveverticaltxt.png'
import purplenexticon from './../../../images/purplenexticon.png'
import Landingdots1 from './../../../images/landingdots1.png'
import Landingdots2 from './../../../images/landingdots2.png'
import Landingdots3 from './../../../images/landingdots3.png'
import Landingdots4 from './../../../images/landingdots4.png'
import Landingdots5 from './../../../images/landingdots5.png'
import Landingdots6 from './../../../images/landingdots6.png'
import Landingdots7 from './../../../images/landingdots7.png'
import Landingdots8 from './../../../images/landingdots8.png'
import Landingdots9 from './../../../images/landingdots9.png'
import WhatN3rveline1 from './../../../images/whatn3rveline1.png'
import WhatN3rveline2 from './../../../images/whatn3rveline2.png'
import WhatN3rveline3 from './../../../images/whatn3rveline3.png'
import WhatN3rveline4 from './../../../images/whatn3rveline4.png'
import WhatN3rveline5 from './../../../images/whatn3rveline5.png'
import WhatN3rveline6 from './../../../images/whatn3rveline6.png'
import whatisnerverightlines from './../../../images/whatisnerverightlines.png'
import whatisnerveleftlines from './../../../images/whatisnerveleftlines.png'
import whatisnerveleftlines2 from './../../../images/whatisnerveleftlines2.png'
import Landingplandotsleft from './../../../images/landingplandotsleft.png'
import Landingplandotsright from './../../../images/landingplandotsright.png'
import LandinginfoLinesL from './../../../images/landinginfolinesL.png'
import LandinginfoLinesR from './../../../images/landinginfolinesR.png'
import LandinginfoDotsR from './../../../images/landinginfodotsR.png'
import LandinginfoDotsL from './../../../images/landinginfodotsL.png'
import LandingFeaturesLine from './../../../images/landingfeaturesvertline.png'
import PurpleNextIcon from './../../../images/purplenexticon.png'
import Blog1Pic from './../../../images/blog1pic.png'
import Blog2Pic from './../../../images/blog2pic.png'
import Blog3Pic from './../../../images/blog3pic.png'
import crossicon from './../../../images/crossicon.png'
import ComparePlanCheck from './../../../images/compareplancheck.png'
import AA from './../../../images/aa.png'
import DSPScroll from './../../../images/dspscroll.png'
// import DspBanner from './../../../images/dspbanner.gif'
import LandingGraph1 from './../../../images/landinggraphic1.png'
import LandingGraph2 from './../../../images/landinggraphic2.png'
import FAQBanner from './../../../images/faqbannerimg.png'
import FAQPlusIcon from './../../../images/faqplusicon.png'
import PurpleFlower from './../../../images/purpleflower.png'
import FAQMinusIcon from './../../../images/faqminusicon.png'
import LandingGraph3 from './../../../images/landinggraphic3.png'
import JoinNerveBtn from './../../../images/joinnervebtn.png'
import ComparePlansBtn from './../../../images/compareplansbtn.png'
import GetStartedBtn from './../../../images/get_started_btn.png'
import DistImg2 from './../../../images/distimg2.png'
import DistImg2Mob from './../../../images/distimg2mob.png'
import ComingSoonBtn from './../../../images/comingsoonbtn.png'
import YourMusicBox from './../../../images/yourmusicbox.png'
import YourMusicBoxMob from './../../../images/yourmusicboxmob.png'
import './LandingPage.css'
import AmazonLogo from './../../../images/amazonmusiclogo.png'
import SoundCloudLogo from './../../../images/soundcloudlogo.png'
import SpotifyLogo from './../../../images/spotifylogo.png'
import AppleMusicLogo from './../../../images/applemusiclogo.png'
import PandoraLogo from './../../../images/pandoralogo.png'
import TidalLogo from './../../../images/tidallogo.png'
import YoutubeMusicLogo from './../../../images/youtubemusiclogo.png'
import AwaLogo from './../../../images/awalogo.png'
import GenieLogo from './../../../images/genielogo.png'
import JooxLogo from './../../../images/jooxlogo.png'
import KKBoxLogo from './../../../images/kkboxlogo.png'
import LineMusicLogo from './../../../images/linemusiclogo.png'
import MelonLogo from './../../../images/melonlogo.png'
import QobuzLogo from './../../../images/qobuzlogo.png'
import RakutenMusicLogo from './../../../images/rakutenmusiclogo.png'
import TencentLogo from './../../../images/tencentlogo.png'
import BlackStar from './../../../images/blackstar.png'
import NervousLogo from './../../../images/nervouslogo.png'
import NervousPlusLogo from './../../../images/nervouspluslogo.png'
import NerveProLogo from './../../../images/nerveprologo.png'
import N3rveLogo from "./../../../images/N3rveLogo.png"
import InviteOnlyLogo from './../../../images/inviteonlylogo.png'
import FAQPlus from './../../../images/faqplus.png'
import FAQMinus from './../../../images/faqminus.png'
import JoinUsBtn from './../../../images/joinusbtn.png'
import BtnTopLeft from './../../../images/btntopleft.png'
import BtnBottomRight from './../../../images/btnbottonright.png'
import japan from './../../../images/japan.jpg'
import girl from './../../../images/girl.jpg'
import billboard from './../../../images/billboard.jpg'
import crown from './../../../images/crown.jpg'
import Footer from "../../Footer/Footer";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import { Parallax, ParallaxLayer } from '@react-spring/parallax'
import { motion } from 'framer-motion';
import ProdcerDots2 from './../../../images/producerdots2.png'
import ArrowDown from './../../../images/arrowdown.png'
import DisclaimerIcon from './../../../images/disclaimerpopup.png'
import ArtistCarousel from "./ArtistCarousel";
import services1 from './../../../images/services1.png'
import services2 from './../../../images/services2.png'
import services3 from './../../../images/services3.png'
import serviceslline1 from './../../../images/serviceslline1.png'
import serviceslline2 from './../../../images/servicelline2.png'
import servicesrline1 from './../../../images/servicerline1.png'
import servicesrline2 from './../../../images/servicerline2.png'
import nervevertlogo from './../../../images/nervevertlogo.png'
import servicellinetab from './../../../images/servicellinetab.png'
import servicerlinemob from './../../../images/servicerlinemob.png'
import servicellinemob from './../../../images/servicellinemob.png'
import NervePlansPage from "./NervePlansPage";
import nervousbox from './../../../images/nervousbox.png'
import nerveplusbox from './../../../images/nerveplusbox.png'
import nerveprobox from './../../../images/nerveprobox.png'
import nexdbox from './../../../images/nexdbox.png'
import horizontal_cut_line from './../../../images/horizontal_cut_line.png'
import vertical_cut_line from './../../../images/vertical_cut_line.png'
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import { logtoWix } from "../../Helpers/LogToWix";
import { useJwt, decodeToken } from "react-jwt";

function LandingPage() {
    const [FAQ1, setFAQ1] = useState(false);
    const [FAQ2, setFAQ2] = useState(false);
    const [FAQ3, setFAQ3] = useState(false);
    const [FAQ4, setFAQ4] = useState(false);
    const [FAQ5, setFAQ5] = useState(false);
    const [FAQ6, setFAQ6] = useState(false);
    const [FAQ7, setFAQ7] = useState(false);
    const [FAQ8, setFAQ8] = useState(false);
    const [FAQ9, setFAQ9] = useState(false);
    const [serviceCardHover1, setServiceCardOver1] = useState(false);
    const [serviceCardHover2, setServiceCardOver2] = useState(false);
    const [serviceCardHover3, setServiceCardOver3] = useState(false);
    const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
    const scrollRef = useRef(null);
    const hasLogged = useRef(false);

    //Blog Scroll for Tablet
    let isDown = false;
    let startX;
    let scrollLeft;



    const handleMouseDown = (e) => {
        isDown = true;
        startX = e.pageX - scrollRef.current.offsetLeft;
        scrollLeft = scrollRef.current.scrollLeft;
    };

    const handleMouseLeave = () => {
        isDown = false;
    };

    const handleMouseUp = () => {
        isDown = false;
    };

    const handleMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed
        scrollRef.current.scrollLeft = scrollLeft - walk;
    };

    //Services Scroll for Tablet
    const servicesscrollRef = useRef(null);
    let isServicesDown = false;
    let startServiceX;
    let scrollServiceLeft;

    const handleServiceMouseDown = (e) => {
        isServicesDown = true;
        startServiceX = e.pageX - servicesscrollRef.current.offsetLeft;
        scrollServiceLeft = servicesscrollRef.current.scrollLeft;
    };

    const handleServiceMouseLeave = () => {
        isServicesDown = false;
    };

    const handleServiceMouseUp = () => {
        isServicesDown = false;
    };

    const handleServiceMouseMove = (e) => {
        if (!isServicesDown) return;
        e.preventDefault();
        const x = e.pageX - servicesscrollRef.current.offsetLeft;
        const walk = (x - startServiceX) * 2; // Scroll speed
        servicesscrollRef.current.scrollLeft = scrollServiceLeft - walk;
    };


    const [timeLeft, setTimeLeft] = useState(null);
    const [bannerIndex, setBannerIndex] = useState(0)
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const cookies = new Cookies(null, { path: '/' });
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })




    const dsps = [
        { icon: <img src={SoundCloudLogo} alt="Soundcloud logo" className="PlatfromCardLogo" /> },
        { icon: <img src={AppleMusicLogo} alt="Apple Music logo" className="PlatfromCardLogo" /> },
        { icon: <img src={SpotifyLogo} alt="Spotify logo" className="PlatfromCardLogo" /> },
        { icon: <img src={YoutubeMusicLogo} alt="Soundcloud logo" className="PlatfromCardLogo" /> },
        { icon: <img src={AwaLogo} alt="Apple Music logo" className="PlatfromCardLogo" /> },
        { icon: <img src={GenieLogo} alt="Spotify logo" className="PlatfromCardLogo" /> },
        { icon: <img src={PandoraLogo} alt="Soundcloud logo" className="PlatfromCardLogo" /> },
        { icon: <img src={JooxLogo} alt="Apple Music logo" className="PlatfromCardLogo" /> },
        { icon: <img src={KKBoxLogo} alt="Spotify logo" className="PlatfromCardLogo" /> },
        { icon: <img src={LineMusicLogo} alt="Soundcloud logo" className="PlatfromCardLogo" /> },
        { icon: <img src={MelonLogo} alt="Apple Music logo" className="PlatfromCardLogo" /> },
        { icon: <img src={AmazonLogo} alt="Spotify logo" className="PlatfromCardLogo" /> },
        { icon: <img src={QobuzLogo} alt="Soundcloud logo" className="PlatfromCardLogo" /> },
        { icon: <img src={RakutenMusicLogo} alt="Apple Music logo" className="PlatfromCardLogo" /> },
        { icon: <img src={TencentLogo} alt="Spotify logo" className="PlatfromCardLogo" /> },
        { icon: <img src={TidalLogo} alt="Soundcloud logo" className="PlatfromCardLogo" /> }
    ]

    const slideWidth = 250 / (dsps.length);
    const duplicatedSlides = [...dsps, ...dsps, ...dsps, ...dsps, ...dsps];

    const [scrollPosition, setScrollPosition] = useState(0);

    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };

    useEffect(() => {
        console.log(scrollPosition)
    }, [scrollPosition])


    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    // useEffect(()=>{
    //     topFunction() 
    // },[])

    const handleResize = () => {
        // console.log(window.innerWidth)
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }



    useEffect(() => {

        topFunction()
        if (cookies.get("btnclick") === "landingjoin2") {
            // myfun("landingjoin2")
        }
        setTimeLeft(4)
        window.addEventListener("resize", handleResize, false);
        //   window.addEventListener('scroll', handleScroll, { passive: true });
        console.log("TTTTTTTTTTTTT")
        console.log(cookies.get("btnclick"))

        //   if(cookies.get("btnclick")==="landingjoin2"){
        //     myfun("MusicalFreedomContainer")
        //   }
        //   return () => {
        //       window.removeEventListener('scroll', handleScroll);
        //   };

        if (!hasLogged.current) {
            if (cookies.get('token') !== undefined) {
                console.log("Token present")
                console.log(decodeToken(cookies.get('token')) !== null)
                if (decodeToken(cookies.get('token')) !== null) {
                    logtoWix(decodeToken(cookies.get('token')).email, "pageview", "LandingPage", { "desc": "User opened the Landing page" })
                    hasLogged.current = true;
                } else {
                    logtoWix("anonymous user", "pageview", "LandingPage", { "desc": "User opened the Landing page" })
                    hasLogged.current = true;
                }
            } else {
                logtoWix("anonymous user", "pageview", "LandingPage", { "desc": "User opened the Landing page" })
                hasLogged.current = true;
            }
        }

        const interval = setInterval(() => {
            setBannerIndex((prevIndex) => (prevIndex + 1) % 4);
        }, 7000);
        return () => clearInterval(interval);


    }, []);



    // useEffect(()=>{
    //     console.log(window.innerHeight)
    //     console.log(window.innerWidth)
    //     setDimensions({ 
    //         height: window.innerHeight,
    //         width: window.innerWidth
    //       })
    // },[window.innerHeight,window.innerWidth])

    // const [language, setLanguage] = useState(Cookies.get('lang'));

    // useEffect(() => {
    //   // your useEffect code 
    //   cookies.get('lang')
    // }, [language]);


    // // Update token with every render when its value has changed.
    // const presenceCookie = Cookies.get("presence");
    // if (authToken !== presenceCookie ) {
    //   setAuthToken(presenceCookie);
    // }

    useEffect(() => {
        console.log(6 ? 'LandingPgDiv1H1' : 'jp-LandingPgDiv1H1')
    }, [cookies.get('lang')])

    // function parallax() {
    //     var s = document.getElementById("floater");
    //   var yPos = 0 - window.pageYOffset/4;	
    //   s.style.top = 50 + yPos + "%";

    //   //alert(yPos);
    // }

    // window.addEventListener("scroll", function(){
    //     parallax();	
    // });

    // useEffect(() => {
    //     let scrollDiv = document.getElementById('scrollDiv');

    //     function handleScroll(e) {
    //         e.preventDefault();
    //         let deltaY = e.deltaY;

    //         if (positionY >= maxY && deltaY < 0) {
    //             setPositionY(positionY => positionY);
    //         } else if (positionY <= minY && deltaY > 0) {
    //             setPositionY(positionY => positionY);
    //         } else {
    //             setPositionY(positionY => positionY - (deltaY * 0.5));
    //         }
    //     }
    //     scrollDiv.addEventListener("wheel", handleScroll);

    //     return () => {
    //         scrollDiv.removeEventListener("wheel", handleScroll);
    //     };
    // }, [positionY]);
    var myfun = function (ele) {
        let offsetTop = document.getElementById(ele).offsetTop;
        var right = document.getElementById("LandingPage");
        window.scrollTo({
            top: offsetTop - 150,
            behavior: "smooth"
        });
    }

    return (
        <div style={{ width: '100vw' }}>


            {/* ******************************************** */}


            {/* DESKTOP VIEW */}

            {
                dimensions.width >= 1024 &&
                <div style={{ width: '100%', height: '100%', textAlign: 'left' }} id="LandingPage">
                    <Parallax >
                        <ParallaxLayer offset={0} speed={0.4} factor={2} style={{
                            width: '150vh',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            justifyContent: 'flex-end',
                            height: '150vh',
                            backgroundSize: '100%',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPositionX: '0vw',
                            zIndex: '-1',
                        }}>



                            <div className={`banner-slide ${bannerIndex === 0 ? 'active' : ''}`} style={{ position: 'absolute', backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/m1msr6bbfgjlu1tozdww")`, height: '150vh', width: '150vw', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }} />
                            <div className={`banner-slide ${bannerIndex === 1 ? 'active' : ''}`} style={{ position: 'absolute', backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/w7yjvxquccvs06xfsaki")`, height: '150vh', width: '150vw', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }} />
                            <div className={`banner-slide ${bannerIndex === 2 ? 'active' : ''}`} style={{ position: 'absolute', backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/stqwbdcgcavxorucccom")`, height: '150vh', width: '150vw', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }} />
                            <div className={`banner-slide ${bannerIndex === 3 ? 'active' : ''}`} style={{ position: 'absolute', backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/aaeo30adopdkyo8cuywr")`, height: '150vh', width: '150vw', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }} />
                        </ParallaxLayer>



                        <div style={{
                            //  backgroundImage:`url(${HomePgImg1})`, 
                            height: '100vh',
                            // height:'50px',
                            width: '100%',
                            backgroundSize: 'cover',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            position: 'relative'
                            //  transform: `translate(0%, ${positionY}px)`
                            // lineHeight:'0px',
                            // margin:'0px',
                            // padding:'0px',
                            // flex:'1'
                        }}

                        >

                            <div style={{ position: 'absolute', bottom: '3em', left: '17%' }}>
                                <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv1H1' : 'jp-LandingPgDiv1H1'} style={{ marginTop: '0em', marginLeft: '0em', width: '7em', textAlign: 'left', fontSize: '4rem' }}> <Trans i18nKey="Empowering" components={{ 1: <br /> }} >
                                    Empowering Artists & Labels
                                </Trans></div>

                                <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv1H2' : 'jp-LandingPgDiv1H2'} style={{ marginLeft: '0em' }}>{t('Releaseunlimited')}</div>

                                <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv1H3' : 'jp-LandingPgDiv1H3'} style={{ marginLeft: '0em', textAlign: 'left' }}>
                                    <Trans i18nKey="Weprovide" components={{ 1: <br /> }}>
                                        We provide the essential tools for distribution, promotion, and fan engagement.<br /> Step into the spotlight where your music belongs.
                                    </Trans>
                                </div>


                                <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '16.93em', height: '4em', marginTop: '1.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => navigate("/Signup")}>
                                    <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
                                    <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />

                                    <div className="Test"> {t('Joinnerve')}
                                        <div className="HoverOverlay" />


                                    </div>

                                </div>

                                <img src={ProdcerDots2} style={{ width: '5.5em', height: '0.18em', marginTop: '1.5em' }} />
                            </div>

                        </div>

                        <div style={{
                            //  backgroundImage:`url(${DspBackground})`, 
                            backgroundColor: '#1c1c1c',
                            height: '30em',
                            // height:'50px',
                            width: '100%',
                            backgroundSize: 'cover',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            position: 'relative'
                            //  transform: `translate(0%, ${positionY}px)`
                            // lineHeight:'0px',
                            // margin:'0px',
                            // padding:'0px',
                            // flex:'1'
                        }}
                        >
                            <div style={{
                                backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/xb3je5zo04fcr2qndmxr")`,
                                height: '30em',
                                // height:'50px',
                                //  width:'61em',
                                width: '61em',
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                position: 'absolute',
                                zIndex: '2'
                            }} />

                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '8.125em', width: '100%', backgroundColor: 'rgba(0,0,0,0.4)', zIndex: '3', marginTop: '7.62em' }}>
                                <div className="DSPH1">
                                    Streamline your music distribution with one upload.
                                </div>
                                <span className="DSPH2">
                                    Reach over <span style={{ color: '#FF6694' }}>150+</span> streaming services worldwide
                                </span>
                            </div>

                            <div style={{
                                width: "100%",
                                position: "relative",
                                height: "8em",
                                overflow: "visible",
                                padding: "3rem 0",
                                margin: "0 auto",
                                marginTop: '-2em',
                                zIndex: '3'
                            }}>
                                <motion.div
                                    style={{ display: 'flex' }}
                                    animate={{
                                        x: ['0%', '-250%'],
                                        transition: {
                                            ease: 'linear',
                                            duration: 60,
                                            repeat: Infinity,
                                        }
                                    }}
                                >
                                    {duplicatedSlides.map((slide, index) => (
                                        <div key={index} style={{ flexShrink: 0 }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "100%"
                                                }}>
                                                {slide.icon}
                                            </div>
                                        </div>
                                    ))}
                                </motion.div>
                            </div>

                        </div>





                        <div style={{
                            backgroundImage: 'linear-gradient(180deg, rgba(23,24,29,1) 79%, rgba(28,39,50,1) 100%)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            paddingTop: '5em',
                            paddingBottom: '8.75em'
                        }}>

                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
                                <img src={serviceslline1} style={{ height: '237.98px', position: 'absolute', left: '-10%', top: '-5em' }} />
                                <img src={serviceslline2} style={{ height: '305.89px', width: '7.45px', position: 'absolute', left: '-20%', top: '9em' }} />
                                <img src={servicesrline1} style={{ height: '245px', position: 'absolute', right: '-10%', bottom: '20em' }} />
                                <img src={servicesrline2} style={{ height: '220.21px', width: '43px', position: 'absolute', right: '-20%', top: '15em' }} />
                                <div className="ServicesH1">Unlock Your Career with Our Services</div>
                                <div className="ServicesH4">Tailored services that scale with who you are.</div>

                                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'none', alignItems: 'center', justifyContent: 'center', marginTop: '1em', width: '100%' }}>
                                    <div className="ServiceCard2" style={{ backgroundImage: `url(${services1})` }} onMouseOver={() => setServiceCardOver1(true)} onMouseLeave={() => setServiceCardOver1(false)}>
                                        <div className={serviceCardHover1 ? "ServiceOverlay" : "ServiceOverlayinvis"} />
                                        <div style={{ marginTop: '2em' }}>


                                        </div>


                                        <div style={{ marginBottom: '2em' }}>
                                            <div className="ServiceCard2H1" style={{ marginTop: '0.5em' }}>For Artists</div>
                                            <div className="ServiceCard2H2" style={{ width: '91%' }}>Experience a platform where resources meet independence, and creative freedom reigns.</div>
                                            <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', marginTop: '1.5em' }} onClick={() => navigate("/Artist")}>
                                                <div className={serviceCardHover1 ? "ServiceCard2BtnMO" : "ServiceCard2Btn"}>Learn More</div>
                                                <img src={purplenexticon} style={{ width: '1.5em', height: '1.5em' }} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ServiceCard2" style={{ backgroundImage: `url(${services2})` }} onMouseOver={() => setServiceCardOver2(true)} onMouseLeave={() => setServiceCardOver2(false)}>
                                        <div className={serviceCardHover2 ? "ServiceOverlay" : "ServiceOverlayinvis"} />
                                        <div style={{ marginTop: '2em' }}>


                                        </div>


                                        <div style={{ marginBottom: '2em' }}>
                                            <div className="ServiceCard2H1" style={{ marginTop: '0.5em' }}>For Producers</div>
                                            <div className="ServiceCard2H2" style={{ width: '91%' }}>Amplify your beats, team up with global artists, and retain mastery over your creations.</div>

                                            <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', marginTop: '1.5em' }} onClick={() => navigate("/Producer")}>
                                                <div className={serviceCardHover2 ? "ServiceCard2BtnMO" : "ServiceCard2Btn"}>Learn More</div>
                                                <img src={purplenexticon} style={{ width: '1.5em', height: '1.5em' }} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ServiceCard2" style={{ backgroundImage: `url(${services3})` }} onMouseOver={() => setServiceCardOver3(true)} onMouseLeave={() => setServiceCardOver3(false)}>
                                        <div className={serviceCardHover3 ? "ServiceOverlay" : "ServiceOverlayinvis"} />
                                        <div style={{ marginTop: '2em' }}>


                                        </div>

                                        <div style={{ marginBottom: '2em' }}>
                                            <div className="ServiceCard2H1" style={{ marginTop: '0.5em' }}>For Labels & Enterprise</div>
                                            <div className="ServiceCard2H2" style={{ width: '84%' }}>Discover rising talent and forge global collaborations—all while keeping control of your label's vision.</div>

                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer', marginTop: '1.5em', zIndex: '2' }} onClick={() => navigate("/label")}>
                                                <div className={serviceCardHover3 ? "ServiceCard2BtnMO" : "ServiceCard2Btn"}>Learn More</div>
                                                <img src={purplenexticon} style={{ width: '1.5em', height: '1.5em' }} />
                                            </div>
                                        </div>
                                    </div>


                                </div>


                            </div>



                        </div>

                        {/* <div style={{ 
                     backgroundImage:`url(${HomePgImg3})`, 

                     width:'100%',
                     backgroundSize:'cover',
                     display:'flex',
                     flexDirection:'column',
                     alignItems:'center',
                     backgroundColor:'#18222B',
                     position:'relative'
                   }}>
                   
                   <span className="LandingPgDiv4H1" style={{marginBottom:'0.5em',zIndex:'2', width:'78.5%',maxWidth:'15.25em',fontSize:'4rem',fontWeight:'500'}}>
                    What is <span style={{color:'#E91353'}}>N3RVE?</span> <span style={{color:'rgba(255,255,255,60%)',fontWeight:'300'}}>&nbsp;&nbsp;\\</span>
                   </span>

                   <img src={LandingFeaturesLine} style={{position:'absolute',width:'1.48em',height:'26.8em',left:'2em',top:'2em',zIndex:'1'}}/>
                   <img src={NerveBlackRose} style={{position:'absolute',width:'30.93em',height:'30.56em',left:'0em',bottom:'5em',zIndex:'1'}}/>
               
        
                   <div  style={{ 
                     backgroundImage:`url(${DistImg1})`,
                   
                     height:'29.8125em',
                     width:'78.5%',
                     maxWidth:'61em',
                     backgroundSize:'cover',
                     display:'flex',
                     flexDirection:'column',
                     alignItems:'flex-end',
                     backgroundColor:'#18222B',
                     marginBottom:'4em',
                     position:'relative',
                     overflow:'visible',
                     zIndex:'1'
                   }}>
                   
                       
                       
                           <img src={LandingGraph1} style={{position:'absolute',width:'8.717em',height:'3.50em',right:'0em',top:'-6em',zIndex:'1'}}/>
                       <div style={{
                        clipPath:'polygon(11% 0, 100% 0, 100% 83%, 90% 100%, 0 100%, 0 16%)',
                        backgroundColor:'rgba(24, 34, 43, 90%)',
                        height:'94.75%',
                        aspectRatio:'1.02',
                        position:'absolute',
                        top:'0.75em',
                        right:'1em',
                        overflow:'visible',
                        display:'flex',
                        flexDirection:'column',
                        zIndex:'2'
                       }}>
                         
                         <div className="DistBinHeader" style={{width:'90%',marginTop:'1.5em',marginLeft:'1.5em'}}>
                         We provide the tools :<br/>
from distribution to marketing
                            </div>

                            <div style={{height:'1px',backgroundColor:'#FFFFFF',width:'90%',zIndex:'4',top:'30.39%',alignSelf:'flex-end',marginTop:'1.5em',marginBottom:'1.5em'}}/>
                             
                               <div className={cookies.get('lang') === 'en' ?  'DistBinDesc': 'jp-DistBinDesc'} style={{maxWidth:'85%',marginLeft:'1.2em',marginTop:'0em'}}>
                               N3RVE is a music distribution and artist services platform that empowers independent musicians to expand their music's global reach while retaining 100% ownership and creative control. It provides essential tools for music distribution, promotion, and fan engagement, allowing you to own your masters, shape your future, and share your music with the world.
                            </div>

                            <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'80%',height:'4em', marginTop:'0.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',alignSelf:'center'}}  onClick={()=>navigate("/Signup")}>
                                <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                                <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                                
                                    <div className="Test" style={{width:'95%'}}> SELL YOUR MUSIC NOW
                                    <div className="HoverOverlay" />
                                
                                    
                                    </div>
                                
                            </div>
                       </div>
                   </div>

                  

                        
                

           </div>

           
            <NervePlansPage/> */}
                        <div style={{
                            backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/aq5imt1clk4bmvddidx0")`,
                            //  height:'119.06em',
                            width: '100%',
                            backgroundSize: 'cover',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            backgroundColor: '#18222B',
                            position: 'relative',
                            paddingTop: '5em',
                            paddingBottom: '5em'
                        }}>
                            <img src={nerveverticaltxt} style={{ zIndex: '1', position: 'absolute', top: '0em', right: '10%' }} />
                            <span className="LandingPgDiv4H1" style={{ marginBottom: '0.5em', zIndex: '2', width: '78.5%', maxWidth: '15.25em', fontSize: '4rem', fontWeight: '500', position: 'relative' }}>
                                What is <span style={{ color: '#E91353' }}>N3RVE?</span> <span style={{ color: 'rgba(255,255,255,60%)', fontWeight: '300' }}>&nbsp;&nbsp;\\</span>

                            </span>

                            {/* <img src={whatisnerveleftlines2} style={{position:'absolute',width:'106.17px',height:'111.3px',left:'1em',bottom:'2em',zIndex:'1'}}/> */}

                            <img src={NerveBlackRose} style={{ position: 'absolute', width: '30.93em', height: '30.56em', left: '0em', bottom: '5em', zIndex: '1' }} />
                            {/* <img src={LandingGraph2} style={{position:'absolute',width:'7.73em',height:'68.44em',left:'5.39em',top:'4.49em'}}/> */}
                            {/*                   
                   <img src={LandingGraph3} style={{position:'absolute',width:'7.23em',height:'23.875em',left:'0',top:'0'}}/> */}

                            <div style={{
                                backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/a3my2t22tavljcqllqcm")`,
                                height: '29.8125em',
                                width: '78.5%',
                                maxWidth: '61em',
                                backgroundSize: 'cover',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-end',
                                backgroundColor: '#18222B',
                                marginBottom: '4em',
                                position: 'relative',
                                overflow: 'visible',
                                zIndex: '1',
                                position: 'relative'
                            }}>

                                <img src={whatisnerverightlines} style={{ position: 'absolute', width: '77.47px', height: '791.22px', right: '-15%', top: '-40%', zIndex: '1' }} />
                                <div style={{ backgroundColor: 'rgba(255,255,255,25%)', height: '1px', width: '150%', position: 'absolute', top: '-0.7em', right: '-50%' }} />
                                <div style={{ backgroundColor: 'rgba(255,255,255,25%)', height: '150%', width: '1px', position: 'absolute', right: '-0.3em', top: '-50%' }} />
                                <img src={LandingFeaturesLine} style={{ position: 'absolute', width: '1.48em', height: '26.8em', left: '-3em', top: '-50%', zIndex: '1' }} />


                                <img src={LandingGraph1} style={{ position: 'absolute', width: '8.717em', height: '3.50em', right: '2em', top: '-6em', zIndex: '1' }} />
                                <div style={{
                                    clipPath: 'polygon(11% 0, 100% 0, 100% 83%, 90% 100%, 0 100%, 0 16%)',
                                    backgroundColor: 'rgba(24, 34, 43, 90%)',
                                    height: '94.75%',
                                    aspectRatio: '1.02',
                                    position: 'absolute',
                                    top: '0.75em',
                                    right: '1em',
                                    overflow: 'visible',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    zIndex: '2'
                                }}>

                                    <div className="DistBinHeader" style={{ width: '90%', marginTop: '1.5em', marginLeft: '1.5em' }}>
                                        We provide the tools :<br />
                                        from distribution to marketing
                                    </div>

                                    <div style={{ height: '1px', backgroundColor: '#FFFFFF', width: '90%', zIndex: '4', top: '30.39%', alignSelf: 'flex-end', marginTop: '1.5em', marginBottom: '1.5em' }} />

                                    <div className={cookies.get('lang') === 'en' ? 'DistBinDesc' : 'jp-DistBinDesc'} style={{ maxWidth: '85%', marginLeft: '1.2em', marginTop: '0em' }}>
                                        N3RVE is a music distribution and artist services platform that empowers independent artist to expand their global reach. With N3RVE, artists retain 100% royalty and creative control, ensuring that you own your masters and hold the power to shape your future.
                                    </div>

                                    <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '80%', height: '4em', marginTop: '0.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', alignSelf: 'center' }} onClick={() => navigate("/Signup")}>
                                        <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
                                        <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />

                                        <div className="Test" style={{ width: '95%' }}> SELL YOUR MUSIC NOW
                                            <div className="HoverOverlay" />


                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'row', width: '78.5%', marginLeft: '0.6em', justifyContent: 'center', alignItems: 'center', zIndex: '1', position: 'relative' }}>

                                <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', maxWidth: '30em' }}>
                                    <div style={{ position: 'relative' }}>
                                        <img src={japan} style={{ maxWidth: '29.43em', height: '20em' }} />
                                        <img src={horizontal_cut_line} style={{ width: '659.85px', height: '1px', position: 'absolute', left: '-50%', top: '0%' }} />
                                        <img src={vertical_cut_line} style={{ height: '433.26px', width: '1px', position: 'absolute', left: '0em', top: '-50%' }} />
                                        <img src={whatisnerveleftlines} style={{ width: '114.6px', height: '240.34px', position: 'absolute', left: '-40%', top: '40%' }} />
                                    </div>

                                    <div className="cut" style={{ width: '340px' }}>
                                        <div className="DistBinHeader" >
                                            GLOBAL DISTRIBUTION
                                        </div>
                                    </div>
                                    <div className="DistBinDesc" style={{ width: '96%' }}>

                                        Unlock the power of global reach with our premier music distribution service, designed to amplify your sound and connect you to audiences worldwide. From indie artists to established labels, our platform ensures your music hits the right playlists, streaming services, and social channels with precision.

                                    </div>

                                    <div style={{ position: 'relative' }}>
                                        <img src={billboard} style={{ width: '29.43em', height: '20em', marginTop: '2.625em' }} />
                                        <img src={horizontal_cut_line} style={{ width: '659.85px', height: '1px', position: 'absolute', left: '-50%', top: '2.625em' }} />
                                        <div style={{ backgroundColor: 'rgba(255,255,255,25%)', width: '1px', height: '301px', position: 'absolute', left: '0em', top: '-2.625em' }} />
                                    </div>
                                    <div className="cut">
                                        <div className="DistBinHeader">
                                            INSTANT INSIGHTS
                                        </div>
                                    </div>
                                    <div className="DistBinDesc" style={{ width: '96%' }}>

                                        Receive daily updates on your music’s performance and playlist sourcing across Apple Music, Spotify, Amazon Music, YouTube Music, and other top DSPs. Our industry-leading analytics dashboard gives you full control, empowering you to make intelligent, data-driven decisions in real time. Stay ahead with insights that matter, when they matter most.

                                    </div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '2.3em', maxWidth: '30em', marginTop: '8.25em', alignSelf: 'center' }}>
                                    <div style={{ position: 'relative' }}>
                                        <img src={crown} style={{ width: '29.43em', height: '20em' }} />
                                        <img src={horizontal_cut_line} style={{ width: '659.85px', height: '1px', position: 'absolute', right: '-50%', top: '0%' }} />
                                        <div style={{ backgroundColor: 'rgba(255,255,255,25%)', width: '1px', height: '370px', position: 'absolute', right: '0.45em', top: '-2.625em' }} />
                                    </div>
                                    <div className="cut" style={{ width: '350px' }}>
                                        <div className="DistBinHeader">
                                            TRANSPARENT ROYALTY
                                        </div>
                                    </div>
                                    <div className="DistBinDesc" style={{ width: '96%' }}>

                                        In an industry often clouded by complex contracts and hidden fees, N3RVE provides clear, straightforward royalty reporting that puts you in control. Track your earnings in real time, understand your revenue sources, and receive accurate payments. Our mission is simple: to give artists the transparency they deserve, empowering you to make informed decisions and truly own your success.

                                    </div>

                                    <div style={{ position: 'relative' }}>
                                        <img src={girl} style={{ width: '29.43em', height: '20em', marginTop: '2.625em' }} />
                                        <img src={horizontal_cut_line} style={{ width: '659.85px', height: '1px', position: 'absolute', right: '-50%', top: '2.625em' }} />
                                        <div style={{ backgroundColor: 'rgba(255,255,255,25%)', width: '1px', height: '370px', position: 'absolute', right: '0.45em', top: '-2.625em' }} />
                                        {/* <div style={{textAlign:'right',position:'absolute',top:'4em',left:'2%',display:'flex',flexDirection:'column',alignItems:'flex-end'}}>

                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.9em',marginBottom:'0.2em',width:'wrap'}}>By</div>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.2em',marginBottom:'0.2em'}}>Invitation</div>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.6em',marginBottom:'0.2em'}}>Only</div>
                                </div> */}
                                    </div>

                                    <div className="cut" style={{ width: '350px' }}>
                                        <div className="DistBinHeader">
                                            COMPLETE PROMOTION
                                        </div>
                                    </div>
                                    <div className="DistBinDesc" style={{ width: '96%' }}>
                                        Elevate your brand with our all-in-one promotional tools. From captivating designs and targeted branding to robust legal support, we’ll help you make a lasting impact. Start your path to global recognition and protect your creative rights with our expert team by your sid
                                    </div>
                                </div>
                            </div>

                        </div>

                        <ArtistCarousel />

                        <div style={{
                            backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/llh6bpjbtdypfhuzqnxk")`,
                            height: '36.625em',
                            width: '100%',
                            backgroundSize: '140%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            backgroundColor: '#131317',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            position: 'relative',
                            overflow: 'hidden'
                        }}>
                            <img src={LandinginfoLinesL} style={{ width: '0.95em', height: '45.39em', position: 'absolute', left: '5%', top: '-15%', zIndex: '1' }} />
                            <img src={LandinginfoLinesR} style={{ width: '0.95em', height: '45.39em', position: 'absolute', right: '5%', top: '-15%', zIndex: '1' }} />
                            <img src={LandinginfoDotsL} style={{ width: '6.65em', height: '10.06em', position: 'absolute', left: '3%', top: '50%', zIndex: '1' }} />
                            <img src={LandinginfoDotsR} style={{ width: '2.06em', height: '34.10em', position: 'absolute', right: '1%', top: '1em', zIndex: '1' }} />
                            <div className="" style={{
                                backgroundImage: `url(${YourMusicBox})`,
                                height: '28.884em',
                                width: '34.75em',
                                backgroundSize: 'cover',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                backgroundColor: '#131317',
                                marginTop: '3.85em'
                            }}>
                                <div className="LandingPgDiv6H1">
                                    <Trans i18nKey="Yourmusicyourterms" components={{ 1: <br /> }} >
                                        Your Music,<br />Your Terms,<br />Our Superstar Team.
                                    </Trans>

                                </div>

                                <div className="LandingPgDiv6H3">
                                    <Trans i18nKey="Weareacommunity" components={{ 1: <br /> }} >
                                        We are a community of prominent independent leaders coming together to champion Artists Rights, and Musical Freedom.<br />
                                        Our suite of services make the process of sharing your music worldwide simple yet effective. Whether you’re a record label, distributor or content owner, we want to put the power of creative independence into your hands.
                                    </Trans>

                                </div>
                            </div>
                        </div>




                        <div style={{
                            backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/uuholpjexmjecagvkzuo")`,
                            height: '38.18em',
                            width: '100%',
                            backgroundSize: 'cover',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            backgroundColor: '#131317',
                            zIndex: '2'
                        }}>
                            <img src={N3rveLogo} style={{ width: '5.87em', height: '1.125em', marginTop: '4.18em', marginLeft: '8.68em' }} />
                            <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv7H1' : 'jp-LandingPgDiv7H1'}>
                                <Trans i18nKey="Musicalfreedom" components={{ 1: <br /> }} >
                                    Musical Freedom<br /> Begins Here
                                </Trans>
                            </div>
                            {/* <div className="LandingPgDiv7H3" style={{marginLeft:'9em'}}>{t('Nomorerestrictive')}</div> */}

                            <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '30.93em', height: '4em', marginLeft: '8.53em', marginTop: '1.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => { navigate("/Signup"); cookies.set('btnclick', "landingjoin2"); }}>
                                <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
                                <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />
                                <div className="TestLarge">
                                    {t('Joinus')}
                                    <div className="HoverOverlay" />
                                </div>
                            </div>
                        </div>

                        <div style={{ zIndex: '2' }}>
                            <Footer />
                        </div>
                    </Parallax>

                </div>
            }




            {/* /****************************************************************************** */}



            {/* /** TABLET VIEW */}
            {
                dimensions.width >= 768 && dimensions.width < 1024 &&
                <div style={{ width: '100vw' }}>
                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/m1msr6bbfgjlu1tozdww")`,
                        height: '32.48em',
                        // height:'50px',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>

                        <img src={Landingdots1} style={{ position: 'absolute', width: '3.84em', height: '6.04em', left: '2.47em', top: '6em' }} />
                        <img src={Landingdots2} style={{ position: 'absolute', width: '2.36em', height: '6.04em', left: '9.77em', top: '6em' }} />
                        <img src={Landingdots1} style={{ position: 'absolute', width: '3.84em', height: '6.04em', left: '2.47em', top: '20.10em' }} />
                        <img src={Landingdots3} style={{ position: 'absolute', width: '3.98em', height: '15.75em', right: '2.14em', top: '5.79em' }} />
                        <img src={Landingdots4} style={{ position: 'absolute', width: '3.98em', height: '2.19em', right: '2.14em', top: '32.87em' }} />

                        <div style={{
                            // height:'50px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                            // lineHeight:'0px',
                            // margin:'0px',
                            // padding:'0px',
                            // flex:'1'
                        }}>
                            <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv1H1' : 'jp-LandingPgDiv1H1'} style={{ paddingTop: '2.21em', textAlign: 'center', fontSize: '3rem', fontWeight: '500', marginLeft: '0' }}> <Trans i18nKey="Empowering" components={{ 1: <br /> }} >
                                Empowering Artists & Labels
                            </Trans></div>

                            <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv1H2' : 'jp-LandingPgDiv1H2'} style={{ paddingTop: '0.1em', textAlign: 'center', fontSize: '1.125rem', fontWeight: '600', marginLeft: '0', maxWidth: '19.11em' }}>{t('Releaseunlimited')}</div>

                            <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv1H3' : 'jp-LandingPgDiv1H3'} style={{ paddingTop: '0em', textAlign: 'center', fontSize: '1rem', fontWeight: '400', marginLeft: '0', maxWidth: '24.57em' }}><Trans i18nKey="Weprovide" components={{ 1: <br /> }}>
                                We provide the essential tools for distribution, promotion, and fan engagement.<br /> Step into the spotlight where your music belongs.
                            </Trans></div>


                            <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '16.93em', height: '4em', marginTop: '1em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => navigate("/Signup")}>
                                <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
                                <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />
                                <div className="Test">
                                    {t('Getstarted')}
                                </div>
                            </div>
                        </div>




                    </div>

                    <div style={{
                        //  backgroundImage:`url(${DspBackground})`, 
                        backgroundColor: '#1c1c1c',
                        height: '30em',
                        // height:'50px',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}
                    >
                        <div style={{
                            backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/xb3je5zo04fcr2qndmxr")`,
                            height: '30em',
                            // height:'50px',
                            //  width:'61em',
                            width: '61em',
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            position: 'absolute',
                            zIndex: '2'
                        }} />

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '10.125em', width: '100%', backgroundColor: 'rgba(0,0,0,0.4)', zIndex: '3', marginTop: '7.62em' }}>
                            <div className="DSPH1" style={{ textAlign: 'center' }}>
                                Streamline your music distribution with one upload.
                            </div>
                            <span className="DSPH2">
                                Reach over <span style={{ color: '#FF6694' }}>150+</span> streaming services worldwide
                            </span>
                        </div>

                        <div style={{
                            width: "100%",
                            position: "relative",
                            height: "8em",
                            overflow: "visible",
                            padding: "3rem 0",
                            margin: "0 auto",
                            marginTop: '0em',
                            zIndex: '3'
                        }}>
                            <motion.div
                                style={{ display: 'flex' }}
                                animate={{
                                    x: ['0%', '-250%'],
                                    transition: {
                                        ease: 'linear',
                                        duration: 60,
                                        repeat: Infinity,
                                    }
                                }}
                            >
                                {duplicatedSlides.map((slide, index) => (
                                    <div key={index} style={{ flexShrink: 0 }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                height: "100%"
                                            }}>
                                            {slide.icon}
                                        </div>
                                    </div>
                                ))}
                            </motion.div>
                        </div>

                    </div>



                    <div style={{
                        backgroundImage: 'linear-gradient(180deg, rgba(23,24,29,1) 79%, rgba(28,39,50,1) 100%)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        paddingTop: '5em',
                        paddingBottom: '3.75em'
                    }}>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', width: '100%' }}>
                            <img src={servicellinetab} style={{ height: '534.41px', width: '15.43px', position: 'absolute', left: '3%', top: '-5em' }} />
                            {/* <img src={serviceslline2} style={{height:'305.89px',width:'7.45px',position:'absolute',left:'-20%',top:'9em'}}/>
                        <img src={servicesrline1} style={{height:'245px',position:'absolute',right:'-10%',bottom:'20em'}}/>
                        <img src={servicesrline2} style={{height:'220.21px',width:'43px',position:'absolute',right:'-20%',top:'15em'}}/> */}
                            <div className="ServicesH1" style={{ textAlign: 'center', fontSize: '2.5rem' }}>Unlock Your Career with Our Services</div>
                            <div className="ServicesH4" style={{ marginBottom: '2.5em' }}>Tailored services that scale with who you are.</div>

                            <div
                                className="services-scrollable-container"
                                ref={servicesscrollRef}
                                onMouseDown={handleServiceMouseDown}
                                onMouseLeave={handleServiceMouseLeave}
                                onMouseUp={handleServiceMouseUp}
                                onMouseMove={handleServiceMouseMove}
                            >

                                <div className="services-scrollable-item" style={{ backgroundColor: 'transparent', width: '3%', border: '1px solid transparent' }}>
                                    <h3 style={{ color: 'transparent' }}>Why Collaboration with Other Artists Can Elevate Your Sound</h3>
                                </div>

                                <div className="services-scrollable-item" style={{ backgroundImage: `url(${services1})` }} onMouseOver={() => setServiceCardOver1(true)} onMouseLeave={() => setServiceCardOver1(false)}>
                                    {/* Example article */}

                                    <div className={serviceCardHover1 ? "ServiceOverlay" : "ServiceOverlayinvis"} />

                                    <div style={{ marginTop: '2em' }}>


                                    </div>


                                    <div style={{ marginBottom: '2em' }}>
                                        <div className="ServiceCard2H1" style={{ marginTop: '0.5em' }}>For Artists</div>
                                        <div className="ServiceCard2H2" style={{ width: '91%' }}>Experience a platform where resources meet independence, and creative freedom reigns.</div>
                                        <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', marginTop: '1.5em' }} onClick={() => navigate("/Artist")}>
                                            <div className={serviceCardHover1 ? "ServiceCard2BtnMO" : "ServiceCard2Btn"}>Learn More</div>
                                            <img src={purplenexticon} />
                                        </div>
                                    </div>

                                </div>

                                <div className="services-scrollable-item" style={{ backgroundImage: `url(${services2})` }} onMouseOver={() => setServiceCardOver2(true)} onMouseLeave={() => setServiceCardOver2(false)}>
                                    {/* Example article */}
                                    <div className={serviceCardHover2 ? "ServiceOverlay" : "ServiceOverlayinvis"} />

                                    <div style={{ marginTop: '2em' }}>


                                    </div>


                                    <div style={{ marginBottom: '2em' }}>
                                        <div className="ServiceCard2H1" style={{ marginTop: '0.5em' }}>For Producers</div>
                                        <div className="ServiceCard2H2" style={{ width: '91%' }}>Amplify your beats, team up with global artists, and retain mastery over your creations.</div>
                                        <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', marginTop: '1.5em' }} onClick={() => navigate("/Artist")}>
                                            <div className={serviceCardHover1 ? "ServiceCard2BtnMO" : "ServiceCard2Btn"}>Learn More</div>
                                            <img src={purplenexticon} />
                                        </div>
                                    </div>
                                </div>

                                <div className="services-scrollable-item" style={{ backgroundImage: `url(${services3})` }} onMouseOver={() => setServiceCardOver3(true)} onMouseLeave={() => setServiceCardOver3(false)}>
                                    {/* Example article */}
                                    <div className={serviceCardHover3 ? "ServiceOverlay" : "ServiceOverlayinvis"} />

                                    <div style={{ marginTop: '2em' }}>


                                    </div>


                                    <div style={{ marginBottom: '2em' }}>
                                        <div className="ServiceCard2H1" style={{ marginTop: '0.5em' }}>For Labels & Enterprise</div>
                                        <div className="ServiceCard2H2" style={{ width: '83%' }}>Discover rising talent and forge global collaborations—all while keeping control of your label's vision.</div>
                                        <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', marginTop: '1.5em' }} onClick={() => navigate("/Artist")}>
                                            <div className={serviceCardHover1 ? "ServiceCard2BtnMO" : "ServiceCard2Btn"}>Learn More</div>
                                            <img src={purplenexticon} />
                                        </div>
                                    </div>
                                </div>

                                <div className="services-scrollable-item" style={{ backgroundColor: 'transparent', width: '40%', border: '1px solid transparent' }}>
                                    <h3 style={{ color: 'transparent' }}>Why Collaboration with Other Artists Can Elevate Your Sound</h3>
                                </div>



                                {/* Example article */}


                                {/* Add more articles as needed */}
                            </div>







                        </div>



                    </div>

                    {/* <div style={{ 
                     backgroundImage:`url(${HomePgImg3})`, 
                    paddingBottom:'5em',
                     width:'100%',
                     backgroundSize:'cover',
                     display:'flex',
                     flexDirection:'column',
                     alignItems:'center',
                     backgroundColor:'#18222B'
                   }}>

                <span className="LandingPgDiv4H1" style={{marginBottom:'0.5em',zIndex:'2',fontSize:'3rem',fontWeight:'500',justifyContent:'center',width:'9em'}}>
                    What is <span style={{color:'#E91353'}}>N3RVE?</span> <span style={{color:'rgba(255,255,255,60%)',fontWeight:'300'}}>&nbsp;&nbsp;\\</span>
                   </span>

                 

                   <img src={DistImg1} style={{ height:'25em',width:'100%'}}/>

                   <div className="DistBinHeader" style={{width:'90%',marginTop:'1em',marginLeft:'1em',alignSelf:'flex-start'}}>
                         We provide the tools :
from distribution to marketing
                            </div>

                    <div style={{height:'1px',backgroundColor:'#FFFFFF',width:'16.93em',zIndex:'4',alignSelf:'flex-start',marginLeft:'2em',marginTop:'1.5em',marginBottom:'1.5em'}}/>
                             
                               <div className={cookies.get('lang') === 'en' ?  'DistBinDesc': 'jp-DistBinDesc'} style={{width:'90%',marginLeft:'-3em',marginTop:'0em'}}>
                               N3RVE is a music distribution and artist services platform that empowers independent musicians to expand their music's global reach while retaining 100% ownership and creative control. It provides essential tools for music distribution, promotion, and fan engagement, allowing you to own your masters, shape your future, and share your music with the world.
                            </div>

                            <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'50%',height:'4em', marginTop:'1em',marginBottom:'2em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',alignSelf:'center'}}  onClick={()=>navigate("/Signup")}>
                                <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                                <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                                
                                    <div className="Test" style={{width:'95%',height:'3em'}}> SELL YOUR MUSIC NOW
                                    <div className="HoverOverlay" />
                                
                                    
                                    </div>
                                
                            </div>


           </div>

           <NervePlansPage/> */}


                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/aq5imt1clk4bmvddidx0")`,
                        //  height:'190.06em',
                        paddingBottom: '5em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        backgroundColor: '#18222B'
                    }}>

                        <span className="LandingPgDiv4H1" style={{ marginBottom: '0.5em', zIndex: '2', fontSize: '3rem', fontWeight: '500', justifyContent: 'center', width: '9em' }}>
                            What is <span style={{ color: '#E91353' }}>N3RVE?</span> <span style={{ color: 'rgba(255,255,255,60%)', fontWeight: '300' }}>&nbsp;&nbsp;\\</span>
                        </span>

                        {/* <img src={LandingGraph3} style={{position:'absolute',width:'7.23em',height:'23.875em',left:'11.407vh',top:'128.375em'}}/> */}

                        <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/a3my2t22tavljcqllqcm"} style={{ height: '25em', width: '100%' }} />

                        <div className="DistBinHeader" style={{ width: '90%', marginTop: '1em', marginLeft: '1em', alignSelf: 'flex-start' }}>
                            We provide the tools :
                            from distribution to marketing
                        </div>

                        <div style={{ height: '1px', backgroundColor: '#FFFFFF', width: '16.93em', zIndex: '4', alignSelf: 'flex-start', marginLeft: '2em', marginTop: '1.5em', marginBottom: '1.5em' }} />

                        <div className={cookies.get('lang') === 'en' ? 'DistBinDesc' : 'jp-DistBinDesc'} style={{ width: '90%', marginLeft: '-3em', marginTop: '0em' }}>
                            N3RVE is a music distribution and artist services platform that empowers independent artist to expand their global reach. With N3RVE, artists retain 100% royalty and creative control, ensuring that you own your masters and hold the power to shape your future.
                        </div>

                        <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '50%', height: '4em', marginTop: '1em', marginBottom: '2em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', alignSelf: 'center' }} onClick={() => navigate("/Signup")}>
                            <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
                            <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />

                            <div className="Test" style={{ width: '95%', height: '3em' }}> SELL YOUR MUSIC NOW
                                <div className="HoverOverlay" />


                            </div>

                        </div>

                        <div style={{ width: '95%', alignSelf: 'center', marginBottom: '2em' }}>
                            <img src={japan} style={{ width: '95%', height: '28em' }} />
                            <div className="cuttablet" >
                                <div className="DistBinHeader" style={{ zIndex: '2', marginLeft: '-0.5em' }}>
                                    GLOBAL DISTRIBUTION
                                </div>
                            </div>
                            <div className="DistBinDesc" style={{ maxWidth: '95%', marginTop: '0em' }}>

                                Unlock the power of global reach with our premier music distribution service, designed to amplify your sound and connect you to audiences worldwide. From indie artists to established labels, our platform ensures your music hits the right playlists, streaming services, and social channels with precision.


                            </div>

                        </div>

                        <div style={{ width: '95%', alignSelf: 'center', marginBottom: '2em' }}>
                            <img src={crown} style={{ width: '95%', height: '28em' }} />
                            <div className="cuttablet" >
                                <div className="DistBinHeader" style={{ zIndex: '2', marginLeft: '-0.5em' }}>
                                    TRANSPARENT ROYALTY
                                </div>
                            </div>
                            <div className="DistBinDesc" style={{ maxWidth: '95%', marginTop: '0em' }}>
                                In an industry often clouded by complex contracts and hidden fees, N3RVE provides clear, straightforward royalty reporting that puts you in control. Track your earnings in real time, understand your revenue sources, and receive accurate payments. Our mission is simple: to give artists the transparency they deserve, empowering you to make informed decisions and truly own your success.

                            </div>
                        </div>

                        <div style={{ width: '95%', alignSelf: 'center', marginBottom: '2em' }}>
                            <img src={billboard} style={{ width: '95%', height: '28em' }} />
                            <div className="cuttablet">
                                <div className="DistBinHeader" style={{ zIndex: '2', marginLeft: '-0.5em' }}>
                                    INSTANT INSIGHTS
                                </div>
                            </div>
                            <div className="DistBinDesc" style={{ maxWidth: '95%', marginTop: '0em' }}>
                                Receive daily updates on your music’s performance and playlist sourcing across Apple Music, Spotify, Amazon Music, YouTube Music, and other top DSPs. Our industry-leading analytics dashboard gives you full control, empowering you to make intelligent, data-driven decisions in real time. Stay ahead with insights that matter, when they matter most.
                            </div>
                        </div>

                        <div style={{ width: '95%', alignSelf: 'center', marginBottom: '1em' }}>
                            <div style={{ position: 'relative' }}>
                                <img src={girl} style={{ width: '95%', height: '28em' }} />
                                {/* <div style={{textAlign:'right',position:'absolute',top:'1.8em',left:'4.5%',display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.5rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.9em',marginBottom:'0.2em'}}>By</div>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.5rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.5em',marginBottom:'0.2em'}}>Invitation</div>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.5rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'1em',marginBottom:'0.2em'}}>Only</div>
                                </div> */}
                            </div>

                            <div className="cuttablet">
                                <div className="DistBinHeader" style={{ zIndex: '2', marginLeft: '-0.5em' }}>
                                    COMPLETE PROMOTION </div>
                            </div>
                            <div className="DistBinDesc" style={{ maxWidth: '95%', marginTop: '0em' }}>
                                Elevate your brand with our all-in-one promotional tools. From captivating designs and targeted branding to robust legal support, we’ll help you make a lasting impact. Start your path to global recognition and protect your creative rights with our expert team by your side.
                            </div>
                        </div>


                    </div>

                    <ArtistCarousel />

                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/llh6bpjbtdypfhuzqnxk")`,
                        height: '36.625em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundPosition: 'center',
                        backgroundColor: '#131317',
                        paddingBottom: '3em'
                    }}>
                        <div className="" style={{
                            backgroundImage: `url(${YourMusicBox})`,
                            height: '29.28em',
                            width: '35.3125em',
                            backgroundSize: 'cover',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            backgroundColor: '#131317',
                            backgroundPosition: 'center',
                            marginTop: '3.85em'
                        }}>
                            <div className="LandingPgDiv6H1" style={{ width: '85%', marginLeft: '0em' }}>
                                <Trans i18nKey="Yourmusicyourterms" components={{ 1: <br /> }}  >
                                    Your Music,<br />Your Terms,<br />Our Superstar Team.
                                </Trans>

                            </div>

                            <div className="LandingPgDiv6H3" style={{ width: '85%', marginLeft: '0em' }}>
                                <Trans i18nKey="Weareacommunity" components={{ 1: <br /> }} >
                                    We are a community of prominent independent leaders coming together to champion Artists Rights, and Musical Freedom.<br />
                                    Our suite of services make the process of sharing your music worldwide simple yet effective. Whether you’re a record label, distributor or content owner, we want to put the power of creative independence into your hands.
                                </Trans>

                            </div>
                        </div>
                    </div>



                    <div id="MusicalFreedomContainer" style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/uuholpjexmjecagvkzuo")`,
                        height: '38.18em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        backgroundColor: '#131317',
                        alignItems: 'center'
                    }}>
                        <img src={N3rveLogo} style={{ width: '5.87em', height: '1.125em', marginTop: '4.18em' }} />
                        <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv7H1' : 'jp-LandingPgDiv7H1'} style={{ textAlign: 'center', marginLeft: '0em', fontWeight: '500', fontSize: '3rem' }}>
                            <Trans i18nKey="Musicalfreedom" components={{ 1: <br /> }} >
                                Musical Freedom<br /> Begins Here
                            </Trans>
                        </div>
                        {/* <div className="LandingPgDiv7H3" style={{alignSelf:'center',width:'50%'}}>{t('Nomorerestrictive')}</div> */}

                        <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '26.375em', height: '4em', marginTop: '1.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => { navigate("/Signup"); }}>
                            <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
                            <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />
                            <div className="TestLarge" style={{ width: '95%', height: '3em' }}>
                                {t('Joinus')}
                            </div>
                        </div>
                    </div>



                    <Footer />
                </div>
            }


            {/* /****************************************************************************** */}


            {/* /** MOBILE VIEW */}
            {
                dimensions.width < 768 &&
                <div style={{ width: '100vw' }}>
                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/m1msr6bbfgjlu1tozdww")`,
                        //  height:'30.48em',
                        // height:'50px',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        paddingBottom: '5em'
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>

                        <img src={Landingdots1} style={{ position: 'absolute', width: '3.84em', height: '6.04em', left: '2.47em', top: '6em' }} />
                        <img src={Landingdots2} style={{ position: 'absolute', width: '2.36em', height: '6.04em', left: '9.77em', top: '6em' }} />
                        <img src={Landingdots1} style={{ position: 'absolute', width: '3.84em', height: '6.04em', left: '2.47em', top: '20.10em' }} />
                        <img src={Landingdots3} style={{ position: 'absolute', width: '3.98em', height: '15.75em', right: '2.14em', top: '5.79em' }} />
                        <img src={Landingdots4} style={{ position: 'absolute', width: '3.98em', height: '2.19em', right: '2.14em', top: '32.87em' }} />

                        <div style={{
                            // height:'50px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                            // lineHeight:'0px',
                            // margin:'0px',
                            // padding:'0px',
                            // flex:'1'
                        }}>
                            <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv1H1' : 'jp-LandingPgDiv1H1'} style={{ paddingTop: '4.607em', textAlign: 'center', fontSize: '1.75rem', fontWeight: '500', marginLeft: '0' }}> <Trans i18nKey="EmpoweringMob" components={{ 1: <br /> }} >
                                Empowering Artists & Labels
                            </Trans></div>

                            <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv1H2' : 'jp-LandingPgDiv1H2'} style={{ paddingTop: '0.3em', textAlign: 'center', fontSize: '1rem', fontWeight: '600', marginLeft: '0', maxWidth: '65%' }}>{t('Releaseunlimited')}</div>

                            <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv1H3' : 'jp-LandingPgDiv1H3'} style={{ paddingTop: '0em', textAlign: 'center', fontSize: '1rem', fontWeight: '400', marginLeft: '0', maxWidth: '70%' }}><Trans i18nKey="Weprovide" components={{ 1: <br /> }}>
                                We provide the essential tools for distribution, promotion, and fan engagement.<br /> Step into the spotlight where your music belongs.
                            </Trans></div>


                            <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '50%', height: '4em', marginTop: '0.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => navigate("/Signup")}>
                                <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
                                <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />
                                <div className="Test" style={{ width: '95%' }}>
                                    {t('Getstarted')}
                                </div>
                            </div>
                        </div>




                    </div>

                    <div style={{
                        backgroundColor: '#131317',
                        height: '10.81em',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>


                        {/* <div className='Slider'>
                   <div className='SliderTrack'>
   
                       <img src={SoundCloudLogo} alt="Soundcloud logo" className="PlatfromCardLogo"/>
                     

                   
                       <img src={AppleMusicLogo} alt="Apple Music logo" className="PlatfromCardLogo"  />
                        

                       <img src={SpotifyLogo} alt="Spotify logo" className="PlatfromCardLogo" />
                         

                    
                       <img src={YoutubeMusicLogo} alt="Soundcloud logo" className="PlatfromCardLogo"/>
                    

                     
                       <img src={AwaLogo} alt="Apple Music logo" className="PlatfromCardLogo"/>
                   

                      
                       <img src={GenieLogo} alt="Spotify logo" className="PlatfromCardLogo"/>
                     

                       <img src={PandoraLogo} alt="Soundcloud logo" className="PlatfromCardLogo"/>
                        
                       <img src={JooxLogo} alt="Apple Music logo" className="PlatfromCardLogo"/>
                       

                      <img src={KKBoxLogo} alt="Spotify logo" className="PlatfromCardLogo"/>
                   
                       
                       <img src={LineMusicLogo} alt="Soundcloud logo" className="PlatfromCardLogo"/>
                       

                       <img src={MelonLogo} alt="Apple Music logo" className="PlatfromCardLogo"/>
                       

                      <img src={AmazonLogo} alt="Spotify logo" className="PlatfromCardLogo"/>
                         

                       <img src={QobuzLogo} alt="Soundcloud logo" className="PlatfromCardLogo"/>
                       

                      
                       <img src={RakutenMusicLogo} alt="Apple Music logo" className="PlatfromCardLogo"/>
                         
                      
                       <img src={TencentLogo} alt="Spotify logo" className="PlatfromCardLogo"/>
                         
                      
                       <img src={TidalLogo} alt="Soundcloud logo" className="PlatfromCardLogo"/>
                       
                       <img src={SoundCloudLogo} alt="Apple Music logo" className="PlatfromCardLogo"/>
                       

                      <img src={AppleMusicLogo} alt="Spotify logo" className="PlatfromCardLogo"/>

                      <img src={SpotifyLogo} alt="Spotify logo" className="PlatfromCardLogo"/>

                      <img src={YoutubeMusicLogo} alt="Soundcloud logo" className="PlatfromCardLogo"/>
                    

                     
                       <img src={AwaLogo} alt="Apple Music logo" className="PlatfromCardLogo"/>
                   

                      
                       <img src={GenieLogo} alt="Spotify logo" className="PlatfromCardLogo"/>
                     

                       <img src={PandoraLogo} alt="Soundcloud logo" className="PlatfromCardLogo"/>
                        
                       <img src={JooxLogo} alt="Apple Music logo" className="PlatfromCardLogo"/>
                       

                      <img src={KKBoxLogo} alt="Spotify logo" className="PlatfromCardLogo"/>
                   
                       
                       <img src={LineMusicLogo} alt="Soundcloud logo" className="PlatfromCardLogo"/>
                       

                       <img src={MelonLogo} alt="Apple Music logo" className="PlatfromCardLogo"/>
                        
                   </div>
             </div> */}

                        <div style={{
                            width: "100%",
                            position: "relative",
                            height: "8em",
                            overflow: "hidden",
                            padding: "3rem 0",
                            margin: "0 auto",
                            marginTop: '-2em',
                            zIndex: '3'
                        }}>
                            <motion.div
                                style={{ display: 'flex' }}
                                animate={{
                                    x: ['0%', '-250%'],
                                    transition: {
                                        ease: 'linear',
                                        duration: 60,
                                        repeat: Infinity,
                                    }
                                }}
                            >
                                {duplicatedSlides.map((slide, index) => (
                                    <div key={index} style={{ flexShrink: 0 }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                height: "100%"
                                            }}>
                                            {slide.icon}
                                        </div>
                                    </div>
                                ))}
                            </motion.div>
                        </div>

                        <span className="LandingPgDiv2H3" style={{ fontSize: '1rem', fontWeight: '400', lineHeight: '120%', textAlign: 'center', marginTop: '-2em', marginBottom: '2em' }}>
                            DISTRIBUTE TO &nbsp;<span style={{ color: '#E91353', fontWeight: '600' }}>150+</span>&nbsp;PLATFORMS
                        </span>

                    </div>


                    <div style={{
                        backgroundImage: 'linear-gradient(180deg, rgba(23,24,29,1) 79%, rgba(28,39,50,1) 100%)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        paddingTop: '5em',
                        paddingBottom: '1.75em'
                    }}>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', width: '90%' }}>
                            <img src={servicellinemob} style={{ height: '1244.75px', width: '12.58px', position: 'absolute', left: '2%', top: '-5em' }} />
                            <img src={servicerlinemob} style={{ height: '1139.23px', width: '14.58px', position: 'absolute', right: '2%', top: '15em' }} />
                            {/*                         
                        <img src={serviceslline1} style={{height:'237.98px',position:'absolute',left:'-10%',top:'-5em'}}/>
                        <img src={serviceslline2} style={{height:'305.89px',width:'7.45px',position:'absolute',left:'-20%',top:'9em'}}/>
                        <img src={servicesrline1} style={{height:'245px',position:'absolute',right:'-10%',bottom:'20em'}}/>
                        <img src={servicesrline2} style={{height:'220.21px',width:'43px',position:'absolute',right:'-20%',top:'15em'}}/> */}

                            <div className="ServicesH1" style={{ textAlign: 'center', fontSize: '1.75rem' }}>Unlock Your Career with Our Services</div>
                            <div className="ServicesH4">Tailored services that scale with who you are.</div>

                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', marginTop: '1em', width: '100%' }}>
                                <div className="ServiceCard2" style={{ backgroundImage: `url(${services1})`, width: '80%' }} onMouseOver={() => setServiceCardOver1(true)} onMouseLeave={() => setServiceCardOver1(false)}>
                                    <div className={serviceCardHover1 ? "ServiceOverlay" : "ServiceOverlayinvis"} />
                                    <div style={{ marginTop: '2em' }}>


                                    </div>


                                    <div style={{ marginBottom: '2em' }}>
                                        <div className="ServiceCard2H1" style={{ marginTop: '0.5em' }}>For Artists</div>
                                        <div className="ServiceCard2H2" style={{ width: '91%' }}>Experience a platform where resources meet independence, and creative freedom reigns.</div>
                                        <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', marginTop: '1.5em' }} onClick={() => navigate("/Artist")}>
                                            <div className={serviceCardHover1 ? "ServiceCard2BtnMO" : "ServiceCard2Btn"}>Learn More</div>
                                            <img src={purplenexticon} />
                                        </div>
                                    </div>
                                </div>

                                <div className="ServiceCard2" style={{ backgroundImage: `url(${services2})`, width: '80%' }} onMouseOver={() => setServiceCardOver2(true)} onMouseLeave={() => setServiceCardOver2(false)}>
                                    <div className={serviceCardHover2 ? "ServiceOverlay" : "ServiceOverlayinvis"} />
                                    <div style={{ marginTop: '2em' }}>


                                    </div>


                                    <div style={{ marginBottom: '2em' }}>
                                        <div className="ServiceCard2H1" style={{ marginTop: '0.5em' }}>For Producers</div>
                                        <div className="ServiceCard2H2" style={{ width: '91%' }}>Amplify your beats, team up with global artists, and retain mastery over your creations.</div>

                                        <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', marginTop: '1.5em' }} onClick={() => navigate("/Producer")}>
                                            <div className={serviceCardHover2 ? "ServiceCard2BtnMO" : "ServiceCard2Btn"}>Learn More</div>
                                            <img src={purplenexticon} />
                                        </div>
                                    </div>
                                </div>

                                <div className="ServiceCard2" style={{ backgroundImage: `url(${services3})`, width: '80%' }} onMouseOver={() => setServiceCardOver3(true)} onMouseLeave={() => setServiceCardOver3(false)}>
                                    <div className={serviceCardHover3 ? "ServiceOverlay" : "ServiceOverlayinvis"} />
                                    <div style={{ marginTop: '2em' }}>


                                    </div>

                                    <div style={{ marginBottom: '2em' }}>
                                        <div className="ServiceCard2H1" style={{ marginTop: '0.5em' }}>For Labels & Enterprise</div>
                                        <div className="ServiceCard2H2" style={{ width: '83%' }}>Discover rising talent and forge global collaborations—all while keeping control of your label's vision.</div>

                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer', marginTop: '1.5em', zIndex: '2' }} onClick={() => navigate("/label")}>
                                            <div className={serviceCardHover3 ? "ServiceCard2BtnMO" : "ServiceCard2Btn"}>Learn More</div>
                                            <img src={purplenexticon} />
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>



                    </div>
                    {/* 
           <div style={{ 
                     backgroundImage:`url(${HomePgImg3})`, 
                    paddingBottom:'5em',
                     width:'100%',
                     backgroundSize:'cover',
                     display:'flex',
                     flexDirection:'column',
                     alignItems:'center',
                     backgroundColor:'#18222B'
                   }}>
                   
                   <span className="LandingPgDiv4H1" style={{marginBottom:'0.5em',zIndex:'2',fontSize:'1.75rem',fontWeight:'500',justifyContent:'center',width:'9em'}}>
                    What is <span style={{color:'#E91353'}}>N3RVE?</span> <span style={{color:'rgba(255,255,255,60%)',fontWeight:'300'}}>&nbsp;&nbsp;\\</span>
                   </span>

                   <img src={DistImg1} style={{ height:'25em',width:'100%'}}/>

                   <div className="DistBinHeader" style={{width:'90%',marginTop:'1em',marginLeft:'1em',alignSelf:'flex-start',fontSize:'1.75rem'}}>
                         We provide the tools :
from distribution to marketing
                            </div>

                    <div style={{height:'1px',backgroundColor:'#FFFFFF',width:'16.93em',zIndex:'4',alignSelf:'flex-start',marginLeft:'2em',marginTop:'1.5em',marginBottom:'1.5em'}}/>
                             
                               <div className={cookies.get('lang') === 'en' ?  'DistBinDesc': 'jp-DistBinDesc'} style={{width:'90%',marginLeft:'-3em',marginTop:'0em'}}>
                               N3RVE is a music distribution and artist services platform that empowers independent musicians to expand their music's global reach while retaining 100% ownership and creative control. It provides essential tools for music distribution, promotion, and fan engagement, allowing you to own your masters, shape your future, and share your music with the world.
                            </div>

                            <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'90%',height:'4em', marginTop:'1em',marginBottom:'2em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',alignSelf:'center'}}  onClick={()=>navigate("/Signup")}>
                                <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                                <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                                
                                    <div className="Test" style={{width:'95%',height:'3em'}}> SELL YOUR MUSIC NOW
                                    <div className="HoverOverlay" />
                                
                                    
                                    </div>
                                
                            </div>


           </div>

           <NervePlansPage/> */}

                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/aq5imt1clk4bmvddidx0")`,
                        //  height:'170.06em',
                        paddingBottom: '5em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        backgroundColor: '#18222B'
                    }}>

                        <span className="LandingPgDiv4H1" style={{ marginBottom: '0.5em', zIndex: '2', fontSize: '1.75rem', fontWeight: '500', justifyContent: 'center', width: '9em' }}>
                            What is <span style={{ color: '#E91353' }}>N3RVE?</span> <span style={{ color: 'rgba(255,255,255,60%)', fontWeight: '300' }}>&nbsp;&nbsp;\\</span>
                        </span>

                        {/* <img src={LandingGraph3} style={{position:'absolute',width:'7.23em',height:'23.875em',left:'11.407vh',top:'128.375em'}}/> */}

                        <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/a3my2t22tavljcqllqcm"} style={{ height: '25em', width: '100%' }} />

                        <div className="DistBinHeader" style={{ width: '90%', marginTop: '1em', marginLeft: '1em', alignSelf: 'flex-start', fontSize: '1.75rem' }}>
                            We provide the tools :
                            from distribution to marketing
                        </div>

                        <div style={{ height: '1px', backgroundColor: '#FFFFFF', width: '16.93em', zIndex: '4', alignSelf: 'flex-start', marginLeft: '2em', marginTop: '1.5em', marginBottom: '1.5em' }} />

                        <div className={cookies.get('lang') === 'en' ? 'DistBinDesc' : 'jp-DistBinDesc'} style={{ width: '90%', marginLeft: '-3em', marginTop: '0em' }}>
                            N3RVE is a music distribution and artist services platform that empowers independent artist to expand their global reach. With N3RVE, artists retain 100% royalty and creative control, ensuring that you own your masters and hold the power to shape your future.
                        </div>

                        <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '90%', height: '4em', marginTop: '1em', marginBottom: '2em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', alignSelf: 'center' }} onClick={() => navigate("/Signup")}>
                            <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
                            <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />

                            <div className="Test" style={{ width: '95%', height: '3em' }}> SELL YOUR MUSIC NOW
                                <div className="HoverOverlay" />


                            </div>

                        </div>


                        <div style={{ width: '90%', alignSelf: 'center', marginBottom: '1em' }}>
                            <img src={japan} style={{ width: '95%', height: '20em' }} />
                            <div className="cutmobile" >
                                <div className="DistBinHeader" style={{ marginTop: '0em', maxWidth: '100%', fontSize: '1.5rem', marginLeft: '-0.5em' }}>
                                    GLOBAL DISTRIBUTION
                                </div>
                            </div>
                            <div className="DistBinDesc" style={{ maxWidth: '93%', fontSize: '1rem', marginBottom: '1em', alignSelf: 'flex-start', marginTop: '0em' }}>
                                Unlock the power of global reach with our premier music distribution service, designed to amplify your sound and connect you to audiences worldwide. From indie artists to established labels, our platform ensures your music hits the right playlists, streaming services, and social channels with precision.
                            </div>
                        </div>



                        <div style={{ width: '90%', alignSelf: 'center', marginBottom: '1em' }}>
                            <img src={crown} style={{ width: '95%', height: '20em' }} />
                            <div className="cutmobile">
                                <div className="DistBinHeader" style={{ marginTop: '0em', maxWidth: '100%', fontSize: '1.5rem', marginLeft: '-0.5em' }}>
                                    TRANSPARENT ROYALTY
                                </div>
                            </div>
                            <div className="DistBinDesc" style={{ maxWidth: '93%', fontSize: '1rem', marginBottom: '1em', alignSelf: 'flex-start', marginTop: '0em' }}>
                                In an industry often clouded by complex contracts and hidden fees, N3RVE provides clear, straightforward royalty reporting that puts you in control. Track your earnings in real time, understand your revenue sources, and receive accurate payments. Our mission is simple: to give artists the transparency they deserve, empowering you to make informed decisions and truly own your success.
                            </div>
                        </div>

                        <div style={{ width: '90%', alignSelf: 'center', marginBottom: '1em' }}>
                            <img src={billboard} style={{ width: '95%', height: '20em' }} />
                            <div className="cutmobile">
                                <div className="DistBinHeader" style={{ marginTop: '0em', maxWidth: '100%', fontSize: '1.5rem', marginLeft: '-0.5em' }}>
                                    INSTANT INSIGHTS
                                </div>
                            </div>
                            <div className="DistBinDesc" style={{ maxWidth: '93%', fontSize: '1rem', marginBottom: '1em', alignSelf: 'flex-start', marginTop: '0em' }}>
                                Receive daily updates on your music’s performance and playlist sourcing across Apple Music, Spotify, Amazon Music, YouTube Music, and other top DSPs. Our industry-leading analytics dashboard gives you full control, empowering you to make intelligent, data-driven decisions in real time. Stay ahead with insights that matter, when they matter most.
                            </div>
                        </div>

                        <div style={{ width: '90%', alignSelf: 'center', marginBottom: '1em' }}>
                            <div style={{ position: 'relative' }}>
                                <img src={girl} style={{ width: '95%', height: '20em' }} />
                                {/* <div style={{textAlign:'right',position:'absolute',top:'1.5em',left:'5%',display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.9em',marginBottom:'0.2em',width:'wrap'}}>By</div>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.3em',marginBottom:'0.2em'}}>Invitation</div>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.4em',marginBottom:'0.2em'}}>Only</div>
                                </div> */}
                            </div>

                            <div className="cutmobile">
                                <div className="DistBinHeader" style={{ marginTop: '0em', maxWidth: '100%', fontSize: '1.5rem', marginLeft: '-0.5em' }}>
                                    COMPLETE PROMOTION </div>
                            </div>
                            <div className="DistBinDesc" style={{ maxWidth: '93%', fontSize: '1rem', marginBottom: '1em', alignSelf: 'flex-start', marginTop: '0em' }}>
                                Elevate your brand with our all-in-one promotional tools. From captivating designs and targeted branding to robust legal support, we’ll help you make a lasting impact. Start your path to global recognition and protect your creative rights with our expert team by your side.
                            </div>
                        </div>


                    </div>

                    <ArtistCarousel />


                    <div style={{
                        backgroundImage: `url(${HomePgImg5Mob})`,
                        //  height:'40em',
                        paddingBottom: '5em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        backgroundPosition: 'center',
                        backgroundColor: '#131317'
                    }}>
                        <div className="" style={{
                            backgroundImage: `url(${YourMusicBox})`,
                            height: '40.28em',
                            width: '90%',
                            backgroundSize: 'cover',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            backgroundColor: '#131317',
                            backgroundPosition: 'center',
                            marginTop: '5.85em'
                        }}>
                            <div className="LandingPgDiv6H1" style={{ width: '85%', marginLeft: '0em' }}>
                                <Trans i18nKey="Yourmusicyourterms" components={{ 1: <br /> }}  >
                                    Your Music,<br />Your Terms,<br />Our Superstar Team.
                                </Trans>

                            </div>

                            <div className="LandingPgDiv6H3" style={{ width: '85%', marginLeft: '0em' }}>
                                <Trans i18nKey="Weareacommunity" components={{ 1: <br /> }} >
                                    We are a community of prominent independent leaders coming together to champion Artists Rights, and Musical Freedom.<br />
                                    Our suite of services make the process of sharing your music worldwide simple yet effective. Whether you’re a record label, distributor or content owner, we want to put the power of creative independence into your hands.
                                </Trans>

                            </div>
                        </div>
                        {/* <div className="" style={{ 
                     backgroundImage:`url(${YourMusicBoxMob})`, 
                     height:'25.75em',
                     width:'100%',
                     backgroundSize:'cover',
                     display:'flex',
                     flexDirection:'column',
                     alignItems:'center',
                     marginTop:'3.85em'
                   }}>
                       <div className="LandingPgDiv6H1" style={{fontSize:'1.5rem',lineHeight:'120%',marginLeft:'0em',width:'70%'}}>
                       <Trans i18nKey="Yourmusicyourterms" components={{1:<br/>}} >
                       Your Music,<br/>Your Terms,<br/>Our Superstar Team.
                       </Trans>
                          
                       </div>

                       <div className="LandingPgDiv6H3" style={{lineHeight:'120%',marginLeft:'0em',width:'70%',lineHeight:'175%'}}>
                           <Trans i18nKey="Weareacommunitymob" components={{1:<br/>}} >
                           We are a community of prominent independent leaders coming together to champion Artists Rights, and Musical Freedom.
Our suite of services make the process of sharing your music worldwide simple yet effective. Whether you’re a record label, distributor or content owner, we want to put the power of creative independence into your hands.
                       </Trans>
                    
                       </div>
                   </div> */}
                    </div>



                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/uuholpjexmjecagvkzuo")`,
                        height: '38.18em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        backgroundColor: '#131317',
                        alignItems: 'center'
                    }}>
                        <img src={N3rveLogo} style={{ width: '5.87em', height: '1.125em', marginTop: '4.18em' }} />
                        <div className={cookies.get('lang') === 'en' ? 'LandingPgDiv7H1' : 'jp-LandingPgDiv7H1'} style={{ textAlign: 'center', marginLeft: '0em', fontWeight: '500', fontSize: '3rem' }}>
                            <Trans i18nKey="MusicalfreedomMob" components={{ 1: <br /> }} >
                                Musical Freedom<br /> Begins Here
                            </Trans>
                        </div>
                        {/* <div className="LandingPgDiv7H3" style={{alignSelf:'center',width:'90%'}}>{t('Nomorerestrictive')}</div> */}

                        <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '80%', height: '3.5em', marginTop: '1.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => navigate("/Signup")}>
                            <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
                            <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />
                            <div className="TestLarge" style={{ width: '95%', height: '3em' }}>
                                {t('Joinus')}
                            </div>
                        </div>
                    </div>




                    <Footer />
                </div>
            }



        </div>

    );
}

export default LandingPage;